export enum TsepStatusCode {
  PASS = 'PASS',
  FAIL = 'FAIL',
  FAILURE = 'FAILURE',
}
